import axios, { AxiosError } from 'axios'
import * as Redux from 'redux'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { CommonService } from '@Services/common.service'
import { ICommonQuery } from '../../../models/common.model'
import { MIFirearm } from '../../../models/client/firearm.model'
import { ClientActionTypes, ItemTypes } from '../client.action-types'

// const FIREARM = `${APIServices.apiUrlV1}/admin/items`

interface IFirearmParams {
    status?: string
}

const getItems = (type: string, queryParams?: IFirearmParams) => {
    return async function (dispatch: Redux.Dispatch, getState: any) {
        switch (type) {
            case ItemTypes.FIREARM:
                dispatch({
                    type: ClientActionTypes.GET_FIREARMS,
                    payload: [],
                })
                break
            case ItemTypes.ACCESSORY:
                dispatch({
                    type: ClientActionTypes.GET_ACCESSORIES,
                    payload: [],
                })
                break
            case ItemTypes.PART:
                dispatch({
                    type: ClientActionTypes.GET_PARTS,
                    payload: [],
                })
                break
            default:
                break
        }
        dispatch(SharedActions.setClientLoading(true) as any)
        const state = getState()
        const userId = state.auth?.user?.id ? state.auth?.user?.id : ''

        APIServices.axiosConfig()

        const url = `${APIServices.apiUrlV1}/admin/items`
        const headers = APIServices.publicHeader()
        const params = {
            limit: 100,
            type,
            userId,
            ...queryParams,
        }

        axios
            .get(`${url}`, { params, headers })
            .then((res) => {
                dispatch(SharedActions.setClientLoading(false) as any)
                switch (type) {
                    case ItemTypes.FIREARM:
                        dispatch({
                            type: ClientActionTypes.GET_FIREARMS,
                            payload: res?.data,
                        })
                        break
                    case ItemTypes.ACCESSORY:
                        dispatch({
                            type: ClientActionTypes.GET_ACCESSORIES,
                            payload: res?.data,
                        })
                        break
                    case ItemTypes.PART:
                        dispatch({
                            type: ClientActionTypes.GET_PARTS,
                            payload: res?.data,
                        })
                        break
                    default:
                        break
                }
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const createFirearms = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/items`

            axios
                .post(url, payload)
                .then((response) => {
                    // dispatch({
                    //     type: ClientActionTypes.GET_PRODUCT_DETAIL,
                    //     payload: new MProductDetail(response?.data?.data),
                    // })
                    dispatch(SharedActions.setClientLoading(false) as any)
                    const itemType = CommonService.textCapitalize(payload?.type)
                    ToastServices.success(`${itemType} Created`)
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch(SharedActions.setClientLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const getFirearmDetail = (type: string, id: string) => {
    return async function (dispatch: Redux.Dispatch, getState: any) {
        dispatch(SharedActions.setClientLoading(true) as any)
        const state = getState()
        const userId = state.auth?.user?.id ? state.auth?.user?.id : ''

        APIServices.axiosConfig()

        const url = `${APIServices.apiUrlV1}/admin/items/${id}`
        const headers = APIServices.publicHeader()
        const params = {
            limit: 100,
            type,
            userId,
        }

        axios
            .get(`${url}`, { params, headers })
            .then((res) => {
                dispatch(SharedActions.setClientLoading(false) as any)
                switch (type) {
                    case ItemTypes.FIREARM:
                        dispatch({
                            type: ClientActionTypes.GET_FIREARM_DETAIL,
                            // payload: new MIFirearm(res?.data),
                            payload: res?.data,
                        })
                        break
                    // case ItemTypes.ACCESSORY:
                    //     dispatch({
                    //         type: ClientActionTypes.GET_ACCESSORIES,
                    //         payload: res?.data,
                    //     })
                    //     break
                    default:
                        break
                }
            })
            .catch((errors) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const updateFirearm = (id: string, payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/items/${id}`

            axios
                .put(url, payload)
                .then((response) => {
                    dispatch(SharedActions.setClientLoading(false) as any)
                    const itemType = CommonService.textCapitalize(payload?.type)
                    ToastServices.success(`${itemType} Updated`)
                    resolve(response)
                })
                .catch((errors) => {
                    dispatch(SharedActions.setClientLoading(false) as any)
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const createDisposeItem = (id: string, payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        APIServices.axiosConfig()
        return new Promise((resolve, reject) => {
            const url = `${APIServices.apiUrlV1}/admin/items/${id}/dispose`

            axios
                .post(url, payload)
                .then((response) => {
                    ToastServices.success('Item Dispose Success')
                    resolve(response)
                })
                .catch((errors) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    reject(errors)
                })
        })
    }
}

const ClientFirearmActions = {
    getItems,
    createFirearms,
    getFirearmDetail,
    updateFirearm,
    createDisposeItem,
}

export default ClientFirearmActions
